import { useNewTranslations } from '@/common/translations';
import { TeamsTable, TeamsTableLegend, Section } from '@/ui/components';

import { ApiWidgetType, StatsTypes } from '../../../constants';
import { useStatsData } from '../../../hooks';
import { mapTableRowsToRowData } from '../../../utils/mapTableRowsToRowData';

const LeagueTable = () => {
  const translate = useNewTranslations();
  const { widget } = useStatsData({
    shouldFetchTeamsData: false,
    widgetType: StatsTypes.LEAGUE_TABLE,
  });

  if (!widget || widget.type !== ApiWidgetType.LEAGUE_TABLE || !widget?.data) {
    return null;
  }

  const { tableRows, colorLegend } = widget.data;

  return (
    <Section
      name={translate('PreMatchStats.Table')}
      contentClassName="p-3 flex flex-col gap-[12px]"
    >
      <Section className="overflow-hidden" contentClassName="px-0 pb-0">
        <TeamsTable rowData={mapTableRowsToRowData(tableRows)} shouldDisplayFormColumn />
      </Section>
      <TeamsTableLegend className="p-2" items={colorLegend} />
    </Section>
  );
};

export default LeagueTable;
